module.exports = __webpack_public_path__ + "static/kb-mobile-b8e097938327a4beb0fdef3f3d2538b4.png";